import React from "react";

export default function CategoryFilter({ categories, selectedCategory, onCategoryChange }) {
  return (
    <div className="flex items-center gap-3 overflow-x-auto pb-2 hide-scrollbar">
      <button
        onClick={() => onCategoryChange('all')}
        className={`px-4 py-2 rounded-full text-14 font-medium whitespace-nowrap transition-all ${
          selectedCategory === 'all'
            ? 'bg-primary text-white'
            : 'bg-white border border-stroke text-secondary hover:border-primary'
        }`}
      >
        All Articles
      </button>
      {categories.map((category) => (
        <button
          key={category.slug}
          onClick={() => onCategoryChange(category.slug)}
          className={`px-4 py-2 rounded-full text-14 font-medium whitespace-nowrap transition-all ${
            selectedCategory === category.slug
              ? 'bg-primary text-white'
              : 'bg-white border border-stroke text-secondary hover:border-primary'
          }`}
        >
          {category.name}
        </button>
      ))}
    </div>
  );
}
